import Grid from '@mui/material/Grid';
import ordenImg from '../../assets/images/menu/orden.svg';
import ordenBusquedaImg from '../../assets/images/menu/orden-busqueda.svg';
import reimprimirImg from '../../assets/images/menu/reimprimir.svg';
import OrdenDigitalImg from '../../assets/images/svg/mobile-qrScan.svg';
import cupoImg from '../../assets/images/menu/cupo.svg';
import { useTheme } from '@emotion/react';
import CardButton from '../../@iosper/components/Card/CardButton';
import { useMediaQuery } from '@mui/material';
import Title from '../../@iosper/components/Page/Title';
import { isMobile } from '../../@iosper/utils/DeviceDetector';

const Orden = () => {
  // Para ver si entró desde mobile o web, si es mobile no muestra la opción de Orden Electrónica
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
  // const matches = useMediaQuery(theme.breakpoints.up('sm'));
  // const isMobileScreen = isMobile() || !matches;

  return (
    <>
      <Title>Órdenes</Title>

      <Grid container spacing={2}>
        {isMobileScreen && (
          <Grid item xs={4} sm={4} lg={4}>
            <CardButton
              title={'Orden Electrónica'}
              description={'Escaneá el código Qr para generar tu Orden Electrónica.'}
              to={'/read-orden'}
              image={OrdenDigitalImg}
              isMobile={isMobileScreen}
            />
          </Grid>
        )}
        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Orden Impresa'}
            description={'Generá ordenes de consulta.'}
            to={'/emitir-orden'}
            image={ordenImg}
            isMobile={isMobileScreen}
          />
        </Grid>

        {isMobileScreen && (
          <Grid item xs={4} sm={4} lg={4}>
            <CardButton
              title={'Validar Orden'}
              description={'Escaneá el código Qr para validar tu Orden.'}
              to={'/read-orden-impresa'}
              image={OrdenDigitalImg}
              isMobile={isMobileScreen}
            />
          </Grid>
        )}

        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Reimpresión'}
            description={'Reimprimí la última Orden Impresa.'}
            to={'/reimprimir-orden'}
            image={reimprimirImg}
            isMobile={isMobileScreen}
          />
        </Grid>

        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Consultar cupo'}
            description={'Consultá cupo de consultas y prácticas.'}
            to={'/consultar-cupo'}
            image={cupoImg}
            isMobile={isMobileScreen}
          />
        </Grid>

        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Consultar ordenes'}
            description={'Consultá las ordenes emitidas.'}
            to={'/consultar-ordenes'}
            image={ordenBusquedaImg}
            isMobile={isMobileScreen}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Orden;
